import React, { lazy } from 'react';
import { CheckIcon } from 'lucide-react';
export function TransformationSection() {
  const benefits = [{
    title: 'PASO 1:',
    description: 'Crear tu producto desde 0'
  }, {
    title: 'PASO 2:',
    description: 'Configurar tu tienda de shopify y dejarla lista para vender'
  }, {
    title: 'PASO 3:',
    description: 'Diseñar tu pagina de ventas + Ads'
  }, {
    title: 'PASO 4:',
    description: 'Lanzar tus campañas de ventas'
  }];
  return <section className="py-8 md:py-12 px-4 bg-[#2F0240] pt-[40px] pb-[40px] mt-[-20px] mb-[-20px] space-y-[16px]" data-id="element-392" data-mp="2j5h38u3x29ti">
      <div className="max-w-5xl mx-auto pt-[10px] pb-[10px] mt-[-15px] mb-[-15px]" data-id="element-393" data-mp="2e7fkkaaekcik">
        <div className="rounded-2xl p-8 md:p-12 mb-8 bg-[#FFFFFF] animate-neon-violet" data-id="element-394" data-mp="299dzxkxbw54z">
          <p className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-395" data-mp="247x3c1lvn4u7">
            EN 1 FINDE SEMANA VAS A APRENDER A👇
          </p>

          <div className="space-y-4" data-id="element-396" data-mp="209r2193t5hgo">
            {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-4 rounded-lg p-4 shadow-sm bg-[#FAC7F3B1]" data-id="element-397" data-mp="f8zn24gwh40h" data-mpi={index}>
                <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-398" data-mp="5dxtmwfldfs3" />
                <span className="text-lg text-gray-700" data-id="element-399" data-mp="abg2ynxitx0m">
                  <span className="font-black uppercase text-[#353135]" data-id="element-400" data-mp="a9wmaw7ydjyb">
                    {benefit.title}
                  </span>{' '}
                  {benefit.description}
                </span>
              </div>)}
          </div>
        </div>

        {/* Beneficios Header */}
        <div className="mb-8 text-center bg-gradient-to-r from-[#9C16A3] to-[#6B0F70] rounded-2xl p-8 border-2 border-purple-400/50" data-id="element-401" data-mp="p2yhsien9lie">
          <h3 className="md:text-4xl font-black text-white uppercase mb-2 text-[25px]" data-id="element-402" data-mp="39ql9cj5kxsa2">
            ¿Qué vas a lograr?
          </h3>
          <div className="space-y-4 text-left max-w-xl mx-auto mt-4" data-id="element-403" data-mp="3dthjrmkyui2x">
            <div className="flex items-start gap-3" data-id="element-404" data-mp="1kaipp85dj7sk">
              <span className="text-green-400 text-2xl leading-none mt-0.5" data-id="element-405" data-mp="1kc22gortn0pl">
                ✔
              </span>
              <p className="text-lg md:text-xl text-purple-100 font-semibold" data-id="element-406" data-mp="1ak64retndclw">
                Generar ingresos REALES desde casa (sin experiencia)
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-407" data-mp="15j09pacild97">
              <span className="text-green-400 text-2xl leading-none mt-0.5" data-id="element-408" data-mp="11kj26pp6m0r9">
                ✔
              </span>
              <p className="text-lg md:text-xl text-purple-100 font-semibold" data-id="element-409" data-mp="wjlnin3droui">
                Ser más LIBRE y manejar tus tiempos, inclusive viajando
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-410" data-mp="mna5rhl0u6so">
              <span className="text-green-400 text-2xl leading-none mt-0.5" data-id="element-411" data-mp="mol77aqzv2gm">
                ✔
              </span>
              <p className="text-lg md:text-xl text-purple-100 font-semibold" data-id="element-412" data-mp="2h0hwoy5vly91">
                Ahorrar tiempo y dinero con un método que realmente FUNCIONA
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-413" data-mp="2tiu7m1v5ll1b">
              <span className="text-green-400 text-2xl leading-none mt-0.5" data-id="element-414" data-mp="2thasiel8hg14">
                ✔
              </span>
              <p className="text-lg md:text-xl text-purple-100 font-semibold" data-id="element-415" data-mp="2ybnfgylx59hm">
                Tu cuenta bancaria se verá así todos los meses👇🏻
              </p>
            </div>
            <div className="mt-6 flex justify-center" data-id="element-416" data-mp="26jz4ogisgv0w">
              <img src="https://cdn.magicpatterns.com/uploads/45ddanw5u3VzgJMscy3orw/WhatsApp_Image_2026-02-06_at_15.22.24.jpg" alt="Cuenta bancaria - resultados reales" loading="lazy" className="w-full max-w-md rounded-xl shadow-lg" data-id="element-417" data-mp="2ajq75hhogzl9" />
            </div>
          </div>
        </div>

        <div className="bg-gray-900 text-white rounded-2xl p-8 md:p-12 text-center pt-[20px] pb-[20px] mt-[-20px] mb-[-20px]" data-id="element-418" data-mp="3r0c7m84zy4h8">
          <p className="text-xl md:text-2xl mb-4 font-[400]" data-id="element-419" data-mp="18ovderw6q65s">
            No prometemos magia. No es "apretar un botón"
          </p>
          <p className="md:text-3xl font-black text-[#FC9DFF] text-[26px]" data-id="element-420" data-mp="13qtx2eq58ky0">
            Prometemos una metodología probada que SÍ funciona✅
          </p>

          <div className="mt-8 max-w-2xl mx-auto" data-id="element-421" data-mp="1cqgp49wzgeee">
            <div className="grid grid-cols-2 gap-3 md:gap-5" data-id="element-422" data-mp="1cpp57wcr053y">
              <img src="https://cdn.magicpatterns.com/uploads/uRxsqcPoU8ZQZhioHMEJMj/WhatsApp_Image_2026-07-16_at_00.27.39.jpg" alt="Resultados de facturación de una tienda online" loading="lazy" className="w-full h-auto rounded-xl border-2 border-[#FC9DFF]/70 shadow-lg" data-id="element-423" data-mp="1rnhjymah0ph3" />
              <img src="https://cdn.magicpatterns.com/uploads/sFiY1kwfjZz6FmrsJACLGV/WhatsApp_Image_2026-07-16_at_00.27.39_(1).jpg" alt="Ingresos diarios de una nueva oferta online" loading="lazy" className="w-full h-auto rounded-xl border-2 border-[#FC9DFF]/70 shadow-lg" data-id="element-424" data-mp="1wf9bp05d518t" />
            </div>
            <p className="mt-6 text-lg md:text-2xl font-bold leading-relaxed text-white" data-id="element-425" data-mp="2tyzfslp9bcim">
              Si a vos también te gustaría lanzar tu oferta este fin de semana y
              empezar a generar ingresos como estos…{' '}
              <span className="text-[#FC9DFF]" data-id="element-426" data-mp="2k005kyouf8ti">seguí deslizando👇</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}